import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";
import log from "logbeacon";
import { EdgenModalCreateAble } from "../EdgenModal";

type WalletLoadingModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
};

export const WalletLoadingModal = ({
  title,
  description,
}: WalletLoadingModalProps) => {
  return (
    <div className="px-6 py-12 bg-background_solid_secondary flex flex-col items-center gap-6">
      <div className="flex justify-center items-center p-[10px] bg-background_white_overlay5 rounded-full">
        <Icon
          name="ic_loading2"
          size={28}
          className={cn("animate-spin p-[6px]")}
        />
      </div>
      <div className="flex flex-col gap-2 items-center">
        <div className="headline_regular_s text-content_primary">{title}</div>
        <div className="body_m text-content_secondary">{description}</div>
      </div>
    </div>
  );
};

export const WalletLoadingModalCallable = async (props: any) => {
  const { modalProps, ...otherProps } = props;
  return new Promise<any>((resolve) => {
    log.debug("[文案]WalletLoadingModalCallable", props);
    EdgenModalCreateAble.call({
      children: (
        <WalletLoadingModal
          onClose={() => {
            EdgenModalCreateAble.end(false);
            resolve(undefined);
          }}
          {...otherProps}
        />
      ),
      onCancel: () => {
        EdgenModalCreateAble.end(false);
        resolve(undefined);
      },
      containerClassName: "!md:w-[400px] !md:rounded-[16px]",
      styles: {
        content: {
          backgroundColor: ospThemes.colors.background_solid_secondary,
          padding: 0,
          borderRadius: "16px",
        },
      },
      centered: true,
      destroyOnClose: true,
      ...modalProps,
    });
  });
};
